<template>
  <v-card class="pa-3" flat>
    <!-- Desktop Tabs -->
    <v-tabs v-model="tab" v-if="!$vuetify.breakpoint.mobile">
      <v-tab v-for="tab in tabs" :to="tab.to" exact :key="tab.to">
        <v-icon class="mr-2">{{ tab.icon }}</v-icon>
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <!-- Mobile Dropdown -->
    <v-menu v-else offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          block
          outlined
          class="mb-4"
        >
          <v-icon left>{{ currentTab.icon }}</v-icon>
          {{ currentTab.title }}
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="tab in tabs"
          :key="tab.to"
          :to="tab.to"
          exact
          link
        >
          <v-list-item-icon>
            <v-icon>{{ tab.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ tab.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <router-view />
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: ['inline'],
  created() {
    this.SET_LOADING(true)
    this.initTags()
      .then(e => {
        this.settings.show_groups = e.data.filter(e => !e.archived).map(t => t.id)
      })
      .finally(() => {
        this.SET_LOADING(false)
      })
  },
  data: () => ({
    filtering: false,
    show_settings: false,
    choose_filter: true,
    settings: {
      show_groups: [],
    },
    tab: null,
    tabs: [
      { title: 'Etenemiset', to: '/data/league-times', icon: 'mdi-run' },
      { title: 'Tehdyt palot', to: '/data/made-outs', icon: 'mdi-close-circle-outline' },
      { title: 'Joukkueet', to: '/data/joukkueet', icon: 'mdi-shield-account-outline' },
    ]
  }),
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // Refresh data when route changes
        if (to.path === '/data/league-times' || to.path === '/data/field-performance') {
          this.$nextTick(() => {
            // Find the LeagueTimes component and call its refresh method
            const leagueTimesComponent = this.$children.find(child => child.$options.name === 'LeagueTimes')
            if (leagueTimesComponent) {
              leagueTimesComponent.refresh()
            }
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters('data', [
      'clips',
      'loading',
      'all_tags'
    ]),
    ...mapGetters('tag', [
      'tag_groups'
    ]),
    currentTab() {
      return this.tabs.find(tab => tab.to === this.$route.path) || this.tabs[0]
    }
  },
  methods: {
    startSearch(e) {
      this.SET_LOADING(true)
      this.SET_CURRENT_FILTER(e)
      this.getFilterDataNoSave({ filter: JSON.stringify(e) })
        .then(e => {
          this.SET_DATA_CLIPS( e.clips.map(c => c.clips).flat() )
        })
        .catch(e => {
          alert(e)
        })
        .finally(() => {
          this.SET_LOADING(false)
          this.filtering = false
          this.choose_filter = false
        })
    },
    ...mapActions('filter', [
      'getFilterDataNoSave'
    ]),
    ...mapActions('tag', [
      'initTags'
    ]),
    ...mapMutations('data', [
      'SET_DATA_CLIPS',
      'SET_LOADING',
      'SET_CURRENT_FILTER'
    ])
  }
}
</script>